class BuyEcoWiseContactReveal extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-contact-value]').forEach((button) => {
      button.addEventListener('click', () => this.reveal(button));
    });
  }

  reveal(button) {
    const value = [...button.dataset.contactValue].reverse().join('');
    const kind = button.dataset.contactKind;

    if (button.dataset.revealed === 'true') {
      window.location.href = `${kind === 'email' ? 'mailto' : 'tel'}:${value}`;
      return;
    }

    button.textContent = value;
    button.dataset.revealed = 'true';
    button.setAttribute('aria-expanded', 'true');
    button.setAttribute('aria-label', `${value}. Select again to ${kind === 'email' ? 'email' : 'call'} BuyEcoWise.`);
  }
}

if (!customElements.get('buyecowise-contact-reveal')) {
  customElements.define('buyecowise-contact-reveal', BuyEcoWiseContactReveal);
}
